import { ApiImageContainer } from '@ibe/api';
import { OfferBaseData } from './supermodels/OfferBaseData';
import { CmsOfferPackage } from './CmsOfferPackage';

export class CmsDealFinderGlobalConfig {
  paxConfigurations?: DealFinderPaxConfiguration[];

  offersSettings?: OfferSettings[];
}

export class DealFinderPaxConfiguration {
  mainPaxConfiguration?: boolean;

  numberOfAdults?: string;

  numberOfChildren?: string;

  numberOfInfants?: string;

  defaultChildrenAges?: string[];

  defaultInfantsAges?: string[];
}

export class OfferSettings extends OfferBaseData {
  calendarIcon?: ApiImageContainer;

  calendarIconDescription?: string;

  calendarPriceColor?: string;

  calendarPriceColorDescription?: string;

  relatedPackages?: CmsOfferPackage[];

  get packages(): CmsOfferPackage[] {
    return this.relatedPackages ?? [];
  }

  static fromRaw(data: Partial<OfferSettings>): OfferSettings {
    const instance = new OfferSettings();
    Object.assign(instance, data);
    return instance;
  }
}
